import ChatBubble from "./ChatBubble";
import AssistantMessage from "./AssistantMessage";

export default function MessageList({ messages, typingMessage }) {
  return (
    <div className="chat-window" style={{ flex: 1, overflowY: "auto" }}>
      {messages.map((msg, i) =>
        msg.sender === "user" ? (
          <ChatBubble key={i} msg={msg} />
        ) : (
          <AssistantMessage key={i} msg={msg} />
        )
      )}

      {typingMessage &&
        (typingMessage.sender === "user" ? (
          <ChatBubble msg={typingMessage} isTyping />
        ) : (
          <AssistantMessage msg={typingMessage} />
        ))}
    </div>
  );
}